import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';


import { Form, FormsModule, ReactiveFormsModule, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment/min/moment-with-locales';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GameDetailsViewModel } from '../../../shared/models/GameModels';
import { Report, ReportText, ReportSkill, ScoutingReportMasterData, SkillsGroupViewModel } from '../../../shared/models/ReportModels';
import { PlayerDetailsViewModel, PlayerPosition } from '../../../shared/models/player.model';
import { GameService } from '../../../shared/services/game.service';
import { ScoutingPlayerService } from '../../../shared/services/scouting-player.service';
import { ScoutingService } from '../../../shared/services/scouting.service';
import { MaterialModule } from '../../../material/material.module';
import { PlayerService } from '../../../shared/services/player.service';
import { GameHeaderSmallComponent } from '../../components/game-header-small/game-header-small.component';
import { PlayerHeaderComponent } from '../../components/player-header/player-header.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlider } from '@angular/material/slider';
import { RatingSlider5Component } from '../../components/rating-slider5/rating-slider5.component';
import { timeout, catchError, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';



@Component({
    selector: 'app-new-report',
    imports: [CommonModule, MaterialModule, ReactiveFormsModule, GameHeaderSmallComponent, PlayerHeaderComponent, MatFormFieldModule, RatingSlider5Component, TranslatePipe
      
    ],
    templateUrl: './new-report.component.html',
    styleUrls: ['./new-report.component.css']
})
export class NewReportComponent implements OnInit {

  PlayerId: string;
  GameId: string;
  TeamId: string;
  ReportId: string;
  Game: GameDetailsViewModel;
  Player: PlayerDetailsViewModel;
  ReportMasterData: ScoutingReportMasterData;
  reportForm: UntypedFormGroup;
  isLoading = true;
  loadError = false;
  mylist = [0,1,2,3,4,5];
  PlayerPositions: PlayerPosition[];
  gameperf_texts=['-','Bad', 'Average','Good', 'Very good', 'Excellent' ];
  gameperf_colors= ['','#ff2c1c','#e9c400','yellowgreen', 'limegreen', '#1e90ff'];

  constructor(
    private route: ActivatedRoute, 
    private _formBuilder: UntypedFormBuilder,
    private _adapter: DateAdapter<any>,
    private snackbar: MatSnackBar,
    @Inject(MAT_DATE_LOCALE) private _locale: string,
    private location: Location,
    private _scoutingplayerService: ScoutingPlayerService,
    private _reportService: ScoutingService,
    private _gameService: GameService,
    private _playerService: PlayerService,
    private cdr: ChangeDetectorRef) { 
  }

  ngOnInit() {

    this._adapter.setLocale('sv');

    //This is for NEW report
    this.GameId = this.route.snapshot.paramMap.get('GameId')??"";
    this.PlayerId = this.route.snapshot.paramMap.get('PlayerId')??"";
    this.TeamId = this.route.snapshot.paramMap.get('TeamId')??"";

    // console.log('New Report - PlayerId:', this.PlayerId, 'GameId:', this.GameId);

    //This is for opening an old report
    this.ReportId = this.route.snapshot.paramMap.get('ReportId')??"";

    //console.log(this.ReportId);

    if(this.ReportId){
        //Get report
        this._reportService.getReport(this.ReportId).subscribe(report=>{
          // console.log(report);
        });

    }

    this.reportForm = this._formBuilder.group({
      PlayerId: this.PlayerId,
      GameId: this.GameId,
      Scout: '',  
      Capacity: '',  
      PlayerType: '',  
      GamePerformance: ['', [Validators.required]],   
      PositionId: '',
      Projection: ['', [Validators.required]],  
      Comment: ['', [Validators.required]],  
      Location: ['', [Validators.required]],  
      ScoutingSourceId: '',
      CurrentLevelRanking: '',
      CurrentLevelRankingModel: 0,
      ReportDate: [new Date(), [Validators.required]],  
      SkillGroups: this._formBuilder.array([
        
      ])
    });

    if (!this.PlayerId) {
      // console.error('No PlayerId provided!');
      this.loadError = true;
      this.isLoading = false;
      this.snackbar.open('No player selected', 'CLOSE', { duration: 3000 });
      return;
    }

    this._playerService.getPlayerPositionsByUserOrganization()
      .pipe(
        take(1),
        catchError(err => {
          console.error('Error fetching player positions:', err);
          this.PlayerPositions = [];
          this.cdr.detectChanges();
          return of([] as PlayerPosition[]);
        })
      )
      .subscribe((positions: PlayerPosition[]) => {
        this.PlayerPositions = positions ?? [];
        this.cdr.detectChanges();
      });

    // console.log('Fetching player data for PlayerId:', this.PlayerId);
    this._playerService.getPlayerScouting(this.PlayerId).pipe(
      timeout(10000),
      catchError(err => {
        // console.error('Error fetching player:', err);
        throw err;
      })
    ).subscribe({
      next: (plyr) => {
        // console.log('Player data received:', plyr);
        this.Player = plyr as PlayerDetailsViewModel;
        this.reportForm.patchValue({'PositionId': this.Player.Player.PositionId});
        this.isLoading = false;
        this.cdr.detectChanges();
        //Get valuelists for capacity, playertype, projection, skills
        // console.log('Fetching report master data for position:', plyr.Player.PositionId);
        this._scoutingplayerService.getReportMasterDataForPosition(plyr.Player.PositionId.toString()).pipe(
          timeout(10000),
          catchError(err => {
            // console.error('Error fetching report master data:', err);
            throw err;
          })
        ).subscribe({
          next: (res) => {
            // console.log('Report master data received:', res);
            this.ReportMasterData = res;
            this.reportForm.patchValue({
              CurrentLevelRankingModel: this.ReportMasterData?.CurrentLevelRankingModel ?? 0
            });
            //Create skills groups
            var skillgroups = this.reportForm.get('SkillGroups') as UntypedFormArray;
            this.ReportMasterData.SkillsGroupsView.forEach((group: SkillsGroupViewModel) => {
              //console.log(group);
              var skills = this._formBuilder.array([]);
              group.Skills.forEach(skill => {
                //console.log(skill);
                skills.push(this._formBuilder.group({
                    SkillGroupId: group.SkillGroupId,
                    SkillId: skill.SkillId,
                    Value: 0
                  })
                );
              });
                
              skillgroups.push(
                this._formBuilder.group({
                  SkillGroupId: group.SkillGroupId,
                  Skills: skills
                })
              );

            });
            // console.log('Report form initialized successfully');
            this.cdr.detectChanges();
          },
          error: (err) => {
            // console.error('Error loading report master data:', err);
            this.snackbar.open('Failed to load report configuration', 'CLOSE', { duration: 3000 });
          }
        });
      },
      error: (err) => {
        // console.error('Error loading player (in error handler):', err);
        this.loadError = true;
        this.isLoading = false;
        const errorMsg = err?.error?.message || err?.message || 'Failed to load player data';
        this.snackbar.open(errorMsg, 'CLOSE', { duration: 3000 });
      }
    });
    //console.log("Getting game");
    if (this.GameId) {
      this._gameService.getGameDetailsSimple(this.GameId).subscribe(data=>{
        this.Game = data as GameDetailsViewModel;
        //console.log(this.Game);
      });
    }
    

  }

    back(){
    this.location.back();
  }

  onSubmit(){
    //console.log('submit');
    //console.log(this.reportForm.get('ReportDate')?.value);
    var newReport = new Report;
    newReport.ReportSkills = [];
    newReport.ReportTexts = [];

    newReport.GameId = this.GameId;
    newReport.PlayerId = this.PlayerId;
    newReport.Location = this.reportForm.get('Location')?.value;
    newReport.PositionId = this.reportForm.get('PositionId')?.value;
    if(this.ReportMasterData.ScoutingSource.length>0){
      newReport.ScoutingSourceId = this.reportForm.get('ScoutingSourceId')?.value;
    }
    newReport.ReportDate = (moment(this.reportForm.get('ReportDate')?.value)).toDate();


    //Currentevel
    
    if(this.ReportMasterData.CurrentLevelEnabled && this.ReportMasterData.CurrentLevel.length>0){
      newReport.CurrentLevelRanking= this.reportForm.get('CurrentLevelRanking')?.value;
      newReport.CurrentLevelRankingModel = this.ReportMasterData.CurrentLevel[0].RankingId;
    }
    


    var comments = new ReportText();
    comments.Text = this.reportForm.get('Comment')?.value;
    comments.TextTypeId = 1;
    newReport.ReportTexts.push(comments);

    var projSkill = new ReportSkill;    
    projSkill.Ranking = this.reportForm.get('Projection')?.value;
    projSkill.SkillGroupId = 0;
    projSkill.SkillId = 1;
    newReport.ReportSkills.push(projSkill);

    var gamePerformance = new ReportSkill;    
    gamePerformance.Ranking = this.reportForm.get('GamePerformance')?.value;
    gamePerformance.SkillGroupId = 0;
    gamePerformance.SkillId = 14;
    newReport.ReportSkills.push(gamePerformance);


    if(this.ReportMasterData.CapacityEnabled){
      var capacitySkill = new ReportSkill;    
      capacitySkill.Ranking = this.reportForm.get('Capacity')?.value;
      capacitySkill.SkillGroupId = 0;
      capacitySkill.SkillId = 24;
      newReport.ReportSkills.push(capacitySkill);
    }


    if(this.ReportMasterData.PlayerTypeEnabled){
      var playerType = new ReportSkill;    
      playerType.Ranking = this.reportForm.get('PlayerType')?.value;
      playerType.SkillGroupId = 0;
      playerType.SkillId = 25;
      newReport.ReportSkills.push(playerType);
    }
    


    var groups = this.reportForm.get('SkillGroups') as UntypedFormArray;
    groups.controls.forEach(group => {
      var skills = group.get('Skills') as UntypedFormArray;
      //console.log(skills);
      skills.controls.forEach(skill=>{
        var newSkill = new ReportSkill;
        newSkill.Ranking = skill.get('Value')?.value;
        newSkill.SkillGroupId = newSkill.SkillId = skill.get('SkillGroupId')?.value;
        newSkill.SkillId = skill.get('SkillId')?.value;
        newReport.ReportSkills.push(newSkill);        
      });
    });
    //console.log(newReport);
    this._reportService.addReport(newReport).subscribe(result=>{
      if(result){
        this.openSnackBar("Report created", "CLOSE");
        this.location.back();
      }else{
        this.openSnackBar("Failed to create report", "CLOSE");
      }
        
    });
  }

  formatLabel(value: number): string {
    if (value == 1) {
      return "Bad";
    }

    return `${value}`;
  }

  log(msg: string){
    // console.log(msg);
  }

  openSnackBar(message: string, action: string) {
    this.snackbar.open(message, action,{
      duration: 2000
    });
  }
  
  getColor():Set<any>{
    
    var lass = new Set();
    lass.add('Bad');
    return lass;
  /*   if (value == 0) {
      return '';
    }
    if (value == 1) {
      return 'Bad';
    }
    if (value == 2) {
      return 'Average';
    }
    if (value == 3) {
      return 'Good';
    }
    if (value == 4) {
      return 'Very_good';
    }
    if (value == 5) {
      return 'Excellent';
    }

    return "";
 */
  }


  getText(value: number):string{
    if (value == 0) {
      return '';
    }
    if (value == 1) {
      return 'Bad';
    }
    if (value == 2) {
      return 'Average';
    }
    if (value == 3) {
      return 'Good';
    }
    if (value == 4) {
      return 'Very_good';
    }
    if (value == 5) {
      return 'Excellent';
    }


    return value.toString();
  }

  getSkillValueText(groupIndex: number, skillIndex: number): string {
    const skillGroups = this.reportForm.get('SkillGroups') as UntypedFormArray;
    const group = skillGroups?.at(groupIndex);
    const skills = group?.get('Skills') as UntypedFormArray;
    const value = skills?.at(skillIndex)?.get('Value')?.value;

    if (value === 1) {
      return 'Bad';
    }
    if (value === 2) {
      return 'Average';
    }
    if (value === 3) {
      return 'Good';
    }
    if (value === 4) {
      return 'Very good';
    }
    if (value === 5) {
      return 'Excellent';
    }

    return '';
  }

  getProjectionColor(value: number){
    var ProjColors = ['lightgray', '#ff2c1c','#e9c400','#e9c400','limegreen','limegreen','limegreen','limegreen','limegreen'];
    return ProjColors[Math.floor(value)];
  }

  getCapacityColor(value: number){
    var ProjColors = ['lightgray', '#ff2c1c','#e9c400','#e9c400','#e9c400','limegreen','limegreen','limegreen','limegreen','limegreen'];
    return ProjColors[Math.floor(value)]      
  }

  getCurrentLevelText(value: number): string {
    var cl = this.ReportMasterData.CurrentLevel.filter(cap=>cap.Ranking==value);
    if(cl.length>0)
      return cl[0].Text;
    else
      return '-';
  }

  getCurrentLevelColor(value: number): string {
    var cl = this.ReportMasterData.CurrentLevel.filter(cap=>cap.Ranking==value);
    if(cl.length>0)
      return cl[0].Color;
    else
      return 'lightgray';
  }

  getCapacityText(value: number){
    console.log(value);
    return this.ReportMasterData.Capacity.filter(cap=>cap.Ranking==value)[0].Text;
  }

  getProjectionText(value: number){
    //console.log(value)          ;
    var proj = this.ReportMasterData.Projection.filter(cap=>cap.Ranking==value);
    //console.log(proj);
    if(proj.length>0)
      return proj[0].Text;
      else
        return '-';
  }

  goBack(){
    this.location.back();
  }

}
